module.exports = __webpack_public_path__ + "img/hkie.bd7638db.png";